import { CircleAlert, Database, LoaderCircle } from "lucide-react";

import type { CteList } from "@/client";
import { FinancePresentation } from "@/presentation/finance";

type Coverage = CteList["coverage"];

export function QiveArchiveCoverage({ coverage }: { coverage: Coverage }) {
	if (!coverage.latest) {
		return (
			<div className="flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
				<CircleAlert className="mt-0.5 size-4 shrink-0" />
				O Acervo Qive ainda não concluiu a primeira coleta deste recurso.
			</div>
		);
	}

	const failed = coverage.latest.state === "failed";
	const completedDescription =
		coverage.latest.mode === "INCREMENTAL" && coverage.latest.recordsSeen === 0
			? "Nenhuma mudança encontrada na última verificação."
			: `${coverage.latest.recordsSeen} registros observados na última coleta.`;

	return (
		<div
			className={`flex items-start gap-3 rounded-2xl border px-4 py-3 text-sm ${
				failed
					? "border-amber-200 bg-amber-50 text-amber-900"
					: "border-emerald-900/10 bg-emerald-50 text-emerald-950"
			}`}
		>
			{coverage.latest.state === "running" ? (
				<LoaderCircle className="mt-0.5 size-4 shrink-0 animate-spin" />
			) : failed ? (
				<CircleAlert className="mt-0.5 size-4 shrink-0" />
			) : (
				<Database className="mt-0.5 size-4 shrink-0" />
			)}
			<p>
				{failed
					? `A última coleta falhou: ${coverage.latest.error ?? "erro não informado"}.`
					: coverage.latest.state === "running"
						? "O Acervo Qive está sendo atualizado."
						: completedDescription}{" "}
				{coverage.lastCompletedAt && (
					<span className="text-current/70">
						Última cobertura concluída {FinancePresentation.moment(coverage.lastCompletedAt)}.
					</span>
				)}
			</p>
		</div>
	);
}
